import { Behavior } from "@mcleod/components/src/base/Behavior";

/**
 * Base behavior class for ImageBundleCapture and ImageBundle components.
 * Provides default sizing and behavior that can be overridden for different device types.
 */
export class ImageBundleBehavior extends Behavior {
    override get type(): string {
        return "ImageBundle";
    }

    /**
     * The size of thumbnail images in pixels.
     * Default: 80px for small screens.
     */
    get thumbnailSize(): number {
        return 80;
    }

    /**
     * The width of the "Add Page" button in pixels.
     * Default: Same as thumbnail size.
     */
    get addPageButtonWidth(): number {
        return this.thumbnailSize;
    }

    /**
     * The height of the "Add Page" button in pixels.
     * Default: Same as thumbnail size.
     */
    get addPageButtonHeight(): number {
        return this.thumbnailSize;
    }

    /**
     * The size of the add icon in the "Add Page" button.
     * Default: 24px for small screens.
     */
    get addPageIconSize(): number {
        return 24;
    }

    /**
     * The font size for the "Add Page" label.
     * Default: "xsmall" for small screens.
     */
    get addPageLabelFontSize(): "xsmall" | "small" | "medium" | "large" {
        return "xsmall";
    }

    /**
     * The size of the delete button on thumbnails.
     * Default: 28px for small screens.
     */
    get thumbnailDeleteButtonSize(): number {
        return 28;
    }

    /**
     * The size of the delete icon inside the delete button.
     * Default: 18px for small screens.
     */
    get thumbnailDeleteIconSize(): number {
        return 18;
    }

    /**
     * Border radius for thumbnails in pixels.
     * Default: 8px.
     */
    get thumbnailBorderRadius(): number {
        return 8;
    }

    /**
     * The margin between thumbnails in pixels.
     * Default: 8px.
     */
    get thumbnailMargin(): number {
        return 8;
    }
}

ImageBundleBehavior.register();
